module.exports = __webpack_public_path__ + "img/tomato_sauce_done.b1d066fa.jpg";